module.exports = __webpack_public_path__ + "img/Icono1-2.c759b123.png";